<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3>Ordenar Categorias de Receita</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row" v-if="!order">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="categoryRecipes">Categorias de Receita</label>
                                    <select name="categoryRecipes[]" id="categoryRecipes" v-model="ordered" size="8" multiple>
                                        <option :value="index" v-for="(categoryRecipe, index) in categoryRecipes">
                                            {{ categoryRecipe.description }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-sm">
                                <button class="btn btn-primary" @click="setCategoryRecipes">Ordenar Categorias de Receita <i class="fa fa-shopping-bag"></i></button>
                            </div>
                        </div>

                        <div class="row" v-if="order">
                            <div class="col-md-12">
                                <draggable v-model="selected" :list="selected" class="dragArea">
                                    <li v-for='(categoryRecipe,index) in selected' :key="categoryRecipe.id" class="list-group-item clearfix draggable">
                                        <i class="mdi mdi-drag pull-left" ></i>
                                        <i class="pull-left fa fa-2x fa-arrows-v align-middle"></i>
                                        <span class="pull-left stages" :id="'stage' + categoryRecipe.id">{{ index + 1 }}. {{ categoryRecipe.description }} </span>
                                        <button class="btn btn-danger pull-right" @click="remove(categoryRecipe, index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </li>
                                </draggable>
                            </div>
                            <div class="col-md-12 m-t-md">
                                <button class="btn btn-info" @click="back"><i class="fa fa-arrow-left"></i> Voltar</button>
                                <button class="btn btn-success" @click="save" style="margin-left:3px;">Salvar Ordenação <i class="fa fa-save"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import { postReorder } from "../../utils";

    export default{
        data: function(){
            return {
                categoryRecipes: [],
                selected: [],
                ordered: [],
                order: false
            }
        },
        components: {
            draggable
        },
        methods: {
            getCategoryRecipesArray: function(data){
                let array = [];
                $.each(data, function(index, value){
                    if(value.sort_by){
                        array.push(index);
                    }
                });
                return array;
            },
            getCategoryRecipes: function(){
                let self = this;
                let api  = self.$store.state.api + 'categoryRecipe?paginated=false';
                let categoryRecipes = $('#categoryRecipes');

                self.$http.get(api)
                    .then((response) => {
                        self.categoryRecipes = response.data.data;
                        self.ordered  = self.getCategoryRecipesArray(self.categoryRecipes);
                    })
                    .then(() => {
                        categoryRecipes.bootstrapDualListbox();
                        categoryRecipes.ready(function () {
                            categoryRecipes.bootstrapDualListbox('refresh', true);
                        });
                    })
                    .catch((error) => {
                        self.$message(null, 'Ocorreu um erro ao buscar os Categorias de Receita', 'error');
                    });
            },
            setCategoryRecipes: function(){
                const self   = this;
                let categoryRecipes = self.selected;

                $('#categoryRecipes').find(':selected').each(function(){
                    categoryRecipes.push(self.categoryRecipes[$(this).val()]);
                });

                self.selected = categoryRecipes;
                self.order = true;
            },
            save: function(){
                const self = this;

                postReorder(self, self.selected, "sort/categoryRecipe", self.getCategoryRecipesArray);
            },
            remove: function(categoryRecipe, index){
                const self = this;
                const api  = self.$store.state.api + 'categoryRecipe/' + categoryRecipe.id;

                let array  = [];
                $.each(self.selected, function(key, value){
                    if(index !== key){
                        array.push(value);
                    }
                });

                self.$http.put(api, {
                    sort_by: null
                })
                    .then((response) => {
                        this.selected = array;
                    });
            },
            back: function(){
                window.location.reload();
            }
        },
        mounted: function(){
            this.getCategoryRecipes();
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CategoryRecipeOrder/Index.vue